import React from 'react';

import cn from 'classnames';

interface LinkProps {
  href?: string;
  label: string;
  disabled: boolean;
  isActive: boolean | null;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
}

export const isProtectedClass =
  'bg-[repeating-linear-gradient(45deg,#6941C6,#6941C6_20px,#7F56D9_20px,#7F56D9_40px)] text-white font-semibold';

export const isProtectedClassOutlined =
  'bg-[repeating-linear-gradient(45deg,#F4EBFF,#F4EBFF_20px,#F9F5FF_20px,#F9F5FF_40px)]';

const checkActivePath = (path, currentLoc) => {
  if (path !== null) {
    return currentLoc.startsWith(path);
  }
};

const Link = ({
  href,
  label,
  disabled,
  isActive,
  icon,
  rightIcon,
  onClick,
}: LinkProps): JSX.Element => {
  const activeClass = 'bg-sp-primary-500 text-white font-semibold';

  let activeMenu;
  if (isActive === null) {
    activeMenu = checkActivePath(href, location.pathname) ? activeClass : null;
  } else {
    activeMenu = isActive ? activeClass : null;
  }

  return (
    <a
      href={href}
      className={cn(
        'menu-link hover:bg-sp-primary-500 my-1 block cursor-pointer px-6 py-2 text-sm leading-5 hover:font-semibold hover:text-white active:text-white',
        activeMenu,
        {
          'cursor-not-allowed opacity-75': disabled === true,
          'flex items-center': icon || rightIcon,
        },
      )}
      onClick={onClick}
    >
      {icon && <span className="inline-bloc mr-2">{icon}</span>}
      {label}
      {rightIcon && <span className="ml-2 inline-block">{rightIcon}</span>}
    </a>
  );
};

export default Link;
